import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ArrowForwardIos } from "@mui/icons-material";

const QuickActions = ({ actions }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "18px",
        border: "1px solid rgba(0,0,0,0.04)",
        padding: "22px 20px",
        backgroundColor: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.02), 0 6px 16px rgba(0,0,0,0.02)",
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          fontSize: "0.82rem",
          fontWeight: 700,
          color: "#0f172a",
          mb: 2,
          letterSpacing: "-0.01em",
        }}
      >
        Acciones rápidas
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, flex: 1, justifyContent: "center" }}>
        {actions.map((action, index) => (
          <Box
            key={index}
            component={Link}
            to={action.path}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              textDecoration: "none",
              color: "inherit",
              padding: "11px 14px",
              borderRadius: "14px",
              backgroundColor: "#fafbfc",
              border: "1px solid #f0f2f5",
              transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                backgroundColor: "#fff",
                borderColor: `${action.color}40`,
                boxShadow: `0 2px 8px ${action.color}15`,
                transform: "translateX(3px)",
                "& .action-arrow": {
                  opacity: 1,
                  color: action.color,
                },
              },
              cursor: "pointer",
            }}
          >
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: "10px",
                background: `linear-gradient(135deg, ${action.color}15 0%, ${action.color}08 100%)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {React.cloneElement(action.icon, {
                sx: { fontSize: 17, color: action.color },
              })}
            </Box>
            <Typography
              sx={{
                fontWeight: 600,
                color: "#334155",
                fontSize: "0.78rem",
                flex: 1,
              }}
            >
              {action.title}
            </Typography>
            <ArrowForwardIos
              className="action-arrow"
              sx={{
                fontSize: 11,
                color: "#cbd5e1",
                opacity: 0,
                transition: "all 0.25s ease",
              }}
            />
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default QuickActions;
